<template>
	<!-------------------graph honoraire modal------------------------>
	<div id="graphModal" class="modal fade" role="dialog">
	    <div class="modal-dialog" role="document">
	        <div class="modal-content" style="border-radius: 6px !important">
	            <div class="modal-header">
	                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
	                <h4 class="modal-title" id="ModalLabel">Honoraire sur les 12 derniers mois</h4>
	            </div>
	            <div class="modal-body" style="padding: 15px;">
	                <div id="graphHonoraireContainer" class="graphContainer" hidden="">
	                 	<canvas id="graphHonoraire" style="height: 250px"></canvas>
	                </div>
                 	<div id="graphBookingContainer" class="graphContainer" hidden="">
                   		<canvas id="graphBooking" style="height: 250px"></canvas>
                 	</div>
               	</div>
	            <div class="modal-footer">
	                 <!--<div class="form-group pull-left" style="margin-bottom: 0px">
	                   <div class="mt-radio-inline">
	                     <label class="mt-radio" style="margin-bottom: 0px">
	                       <input type="radio" name="usersGraphType" id="Honoraire" value="Honoraire" v-model="graphType" v-on:change="graphChange">Honoraires
	                       <span></span>
	                     </label>
	                     <label class="mt-radio" style="margin-bottom: 0px">
	                       <input type="radio" name="usersGraphType" id="Booking" value="Booking" v-model="graphType" v-on:change="graphChange">Réservations
	                       <span></span>
	                     </label>
	                   </div>
	                 </div>-->
	                <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
import moment from "moment";
import 'moment/locale/fr';
moment.locale('fr');
export default {
	name: 'calGraph',
	data() {
	    return {
	    	graphType:"Booking",
	    	graphTitles:{"Honoraire":"Honoraires sur les 12 derniers mois","Booking":"Nombre d'heures réservées"},
	    }
	},
	methods: {
	    graphChange(){
	      $(".graphContainer").hide()
	      $("#ModalLabel").text(this.graphTitles[this.graphType])
	      $("#graph"+this.graphType+"Container").height(250).show();
	    },
	    loadGraph(){
	      	let vueInstance = this;
	      		Promise.all([/*this.loadHonoraireGraph(),*/this.loadBookingGraph()]).then(function(values){//wait for axios
	        	vueInstance.graphChange();
	        	$("#graphModal").modal('show')
	      	})
	    },
	    loadHonoraireGraph(){
	      	return axios.get('billing/getgraphhonoraire')
	         	.then(response => {
		            this.destroyOldGraph("graphHonoraire")
		            let data = response.data
		            let honoraireByUserChart = new ChartHelper("bar",Object.keys(data.honoraireByUser),"","","€",2,false,true,false,false,false,true,false,"","","",false,true);
		            honoraireByUserChart.addDataset("",Object.values(data.honoraireByUser),true,[],0);
		            honoraireByUserChart.getChart($('#graphHonoraire'))
	      		});
	    },
	    loadBookingGraph(){
	      return axios.get('billing/getgraphbooking')
	        .then(response => {
		        this.destroyOldGraph("graphBooking")
		        let data = response.data
		        let bookingByUserChart = new ChartHelper("bar",Object.keys(data.bookingByUser),"","","€",2,false,true,false,false,false,true,false,"","","",false,true);
		        bookingByUserChart.addDataset("",Object.values(data.bookingByUser),true,[],0);
		        bookingByUserChart.getChart($('#graphBooking'))
		        this.graphTitles.Booking="Nombre d'heures réservées du "+moment(data.dates.begin,"YYYY-MM-DD HH:mm:ss").format('ll')+" au "+moment(data.dates.end,"YYYY-MM-DD HH:mm:ss").format('ll')
	      });
	    },
	    destroyOldGraph(graphId){
	      	Chart.helpers.each(Chart.instances, function(instance){//destroy old graph
	        	if(instance.chart.canvas.id==graphId){
	          		instance.destroy();
	        	}
	      	})
	    },
	}
};
</script>